// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.me-3 {
  margin-right: 1rem !important;
}

#main-wrapper, .main-content {
  display: flex;
  flex: 1;
  /* height: 63px; */
  /* border-bottom-left-radius:15px ;
  border-bottom-right-radius: 15px; */
  z-index: 1050;
}

.main-content {
  /* background: #30373E; */

}

.main-content-trans {
  background: transparent !important;
  background-image: none !important;
}



#main-wrapper {
  max-height: 100px;
  height: auto;
  width: 100%;
  /* background-image: url('^assets/images/head-bg.jpg'); */
  background-size: auto;
  background-position: center;
  border: 0;
  margin-bottom: 0;
  /* box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1); */
  /* border-bottom: 1px solid #e6e6e6; */
  padding: 0;
  position: relative;
}

#main-top-bar {
  position: relative;

  height: 100%;
  min-height: 63px;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background: transparent;
  /* background: linear-gradient(90deg, #673AB7, #A910D6); */
  color: #fff;

  padding-left: 1rem;
}

.disable-url-decoration {
  text-decoration: none !important;
}
.disable-url-decoration:hover {
  text-decoration: none !important;
}
.user-dropdown, .user-menu {
  /* position: absolute;
  right: 0; */
  cursor: pointer;
}

.user-menu {
  height: 100%;
  color: #000;
  text-decoration: none !important;
  /* width: 500px; */
  padding: 0 1rem;
  z-index: 10;
}

.user-links {
  color: #fff;
  /* width: 500px; */
  padding: 0 1rem;
  z-index: 10;
}
.user-menu:hover {
  background-color: transparent;
  background-color: rgba(255, 255, 255, 0.1);
  text-decoration: none !important;
}

.user-menu-item {
  height: 100%;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.user-image-wrapper {
  height: 70px;
  background-color: transparent;
  z-index: 20;
}


.circle-frame {
  background-position: 50% 35% !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-color: #d4d4d4 !important;
  border: 1px solid #ececec;
  border-radius: 19%;
  min-width: 10%;
  height: auto;
  padding-top: 10%;
  float: left;
}


.user-image {
  text-align: center;
  display: inline-block;
  margin-top: 14px;
  height: 40px;
  width: 40px;
  border-radius: 10%;
  overflow: hidden;
}

.user-image img {
  width: 100%;
}

.user-name-wrapper {
  color:#000;
  font-weight: bold;
  padding-left: 1rem;
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;
}
.user-menu:hover .user-name-wrapper {
  color:#007bff;
  text-decoration: none;
  padding-left: 1rem;
}

.user-name-wrapper i {
  padding: 0 0.3rem;
}

.user-menu.show {
  background-color: transparent;
  background-color: rgba(255, 255, 255, 0.1);
}

.user-menu.show .user-dropdown {
  box-shadow: -2px 4px 7px #ccc;
  display: block;
}

.user-dropdown {
  position: absolute;
  top: 70px;
  display: none;
  right: 1.5em;
  width: fit-content;
  width:max-content;
  background-color: #fff;
  cursor: pointer;
}

.dropdown-item {
  color: #000;
  display: block;
  padding: 1rem;
  text-decoration: none;
}

.dropdown-item.active {
  color: #fff !important;
  display: block;
  padding: 1rem;
  text-decoration: none;
}

.dropdown-item:hover {
  background-color: #EBF5FF;
  color:#007bff;
}

.dropdown-item.active:hover {
  background-color: #006ee5;
  color:#fff;
}

.dropdown-item span {
  color: #007bff;
  display: inline-block;
  width: 24px;
  text-align: center;
}

.dropdown-item.active span {
  color: #fff;
  display: inline-block;
  width: 24px;
  text-align: center;
}


.ripple {
	box-shadow: 0 0 0 0 rgba(52, 172, 224, 1);
	animation: pulse-blue 2s infinite;
}

@keyframes pulse-blue {
	0% {
		box-shadow: 0 0 0 0 #ffffff;
	}

	70% {
		box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
	}

	100% {
		box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
	}
}


.logo-web {
  display: flex;
}
.logo-mobile {
  display: none;
}

@media (max-width: 991.98px) {
  .logo-web {
    display: none;
  }
  .logo-mobile {
    display: flex;
  }
}

  .profile-picture {
	border-radius: 0.42rem;
	overflow: hidden;
 box-sizing: content-box;
}
  .small-profile-picture {
    border:#ffffffa3 solid 3px;
		width: 50px;
		height: 50px;
	}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/full-screen-dynamic-header/full-screen-dynamic-header.component.css"],"names":[],"mappings":";AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB;qCACmC;EACnC,aAAa;AACf;;AAEA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;;;AAIA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,yDAAyD;EACzD,qBAAqB;EACrB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,gDAAgD;EAChD,sCAAsC;EACtC,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,YAAY;EACZ,gBAAgB;EAChB,WAAW;;EAEX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;;EAEnB,uBAAuB;EACvB,0DAA0D;EAC1D,WAAW;;EAEX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE;aACW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;;AAGA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,uCAAuC;EACvC,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;;AAGA;CACC,yCAAyC;CACzC,iCAAiC;AAClC;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,4CAA4C;CAC7C;;CAEA;EACC,yCAAyC;CAC1C;AACD;;;AAGA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;EAEE;CACD,sBAAsB;CACtB,gBAAgB;CAGd,uBAAuB;AAC1B;EACE;IACE,0BAA0B;EAC5B,WAAW;EACX,YAAY;CACb;;AAAD,w1RAAw1R","sourcesContent":["\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n#main-wrapper, .main-content {\n  display: flex;\n  flex: 1;\n  /* height: 63px; */\n  /* border-bottom-left-radius:15px ;\n  border-bottom-right-radius: 15px; */\n  z-index: 1050;\n}\n\n.main-content {\n  /* background: #30373E; */\n\n}\n\n.main-content-trans {\n  background: transparent !important;\n  background-image: none !important;\n}\n\n\n\n#main-wrapper {\n  max-height: 100px;\n  height: auto;\n  width: 100%;\n  /* background-image: url('^assets/images/head-bg.jpg'); */\n  background-size: auto;\n  background-position: center;\n  border: 0;\n  margin-bottom: 0;\n  /* box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1); */\n  /* border-bottom: 1px solid #e6e6e6; */\n  padding: 0;\n  position: relative;\n}\n\n#main-top-bar {\n  position: relative;\n\n  height: 100%;\n  min-height: 63px;\n  width: 100%;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  background: transparent;\n  /* background: linear-gradient(90deg, #673AB7, #A910D6); */\n  color: #fff;\n\n  padding-left: 1rem;\n}\n\n.disable-url-decoration {\n  text-decoration: none !important;\n}\n.disable-url-decoration:hover {\n  text-decoration: none !important;\n}\n.user-dropdown, .user-menu {\n  /* position: absolute;\n  right: 0; */\n  cursor: pointer;\n}\n\n.user-menu {\n  height: 100%;\n  color: #000;\n  text-decoration: none !important;\n  /* width: 500px; */\n  padding: 0 1rem;\n  z-index: 10;\n}\n\n.user-links {\n  color: #fff;\n  /* width: 500px; */\n  padding: 0 1rem;\n  z-index: 10;\n}\n.user-menu:hover {\n  background-color: transparent;\n  background-color: rgba(255, 255, 255, 0.1);\n  text-decoration: none !important;\n}\n\n.user-menu-item {\n  height: 100%;\n  white-space: nowrap;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.user-image-wrapper {\n  height: 70px;\n  background-color: transparent;\n  z-index: 20;\n}\n\n\n.circle-frame {\n  background-position: 50% 35% !important;\n  background-size: cover !important;\n  background-repeat: no-repeat !important;\n  background-color: #d4d4d4 !important;\n  border: 1px solid #ececec;\n  border-radius: 19%;\n  min-width: 10%;\n  height: auto;\n  padding-top: 10%;\n  float: left;\n}\n\n\n.user-image {\n  text-align: center;\n  display: inline-block;\n  margin-top: 14px;\n  height: 40px;\n  width: 40px;\n  border-radius: 10%;\n  overflow: hidden;\n}\n\n.user-image img {\n  width: 100%;\n}\n\n.user-name-wrapper {\n  color:#000;\n  font-weight: bold;\n  padding-left: 1rem;\n  width: auto;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.user-menu:hover .user-name-wrapper {\n  color:#007bff;\n  text-decoration: none;\n  padding-left: 1rem;\n}\n\n.user-name-wrapper i {\n  padding: 0 0.3rem;\n}\n\n.user-menu.show {\n  background-color: transparent;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.user-menu.show .user-dropdown {\n  box-shadow: -2px 4px 7px #ccc;\n  display: block;\n}\n\n.user-dropdown {\n  position: absolute;\n  top: 70px;\n  display: none;\n  right: 1.5em;\n  width: fit-content;\n  width:max-content;\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.dropdown-item {\n  color: #000;\n  display: block;\n  padding: 1rem;\n  text-decoration: none;\n}\n\n.dropdown-item.active {\n  color: #fff !important;\n  display: block;\n  padding: 1rem;\n  text-decoration: none;\n}\n\n.dropdown-item:hover {\n  background-color: #EBF5FF;\n  color:#007bff;\n}\n\n.dropdown-item.active:hover {\n  background-color: #006ee5;\n  color:#fff;\n}\n\n.dropdown-item span {\n  color: #007bff;\n  display: inline-block;\n  width: 24px;\n  text-align: center;\n}\n\n.dropdown-item.active span {\n  color: #fff;\n  display: inline-block;\n  width: 24px;\n  text-align: center;\n}\n\n\n.ripple {\n\tbox-shadow: 0 0 0 0 rgba(52, 172, 224, 1);\n\tanimation: pulse-blue 2s infinite;\n}\n\n@keyframes pulse-blue {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 #ffffff;\n\t}\n\n\t70% {\n\t\tbox-shadow: 0 0 0 10px rgba(52, 172, 224, 0);\n\t}\n\n\t100% {\n\t\tbox-shadow: 0 0 0 0 rgba(52, 172, 224, 0);\n\t}\n}\n\n\n.logo-web {\n  display: flex;\n}\n.logo-mobile {\n  display: none;\n}\n\n@media (max-width: 991.98px) {\n  .logo-web {\n    display: none;\n  }\n  .logo-mobile {\n    display: flex;\n  }\n}\n\n  .profile-picture {\n\tborder-radius: 0.42rem;\n\toverflow: hidden;\n\t-webkit-box-sizing: content-box;\n  \t-moz-box-sizing: content-box;\n  \tbox-sizing: content-box;\n}\n  .small-profile-picture {\n    border:#ffffffa3 solid 3px;\n\t\twidth: 50px;\n\t\theight: 50px;\n\t}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
